export const dispositionOptions: string[] = [
  'Training',
  'TLO Research',
  'LCP Research',
  'Inbound Calls',
  'Texting & Emailing',
  'FTL Data Entry',
  'Short Break',
  'Long Break',
  'Restroom',
  'Outbound Calls',
  'All Attempts Exhausted',
  'Downtime',
  'Paralegal Task',
  'Amendment/Correction',
  'Active Opportunities on CRM',
];
